<share-buttons 
    [include]="['facebook','twitter', 'whatsapp', 'reddit', 'copy']"
    [show]="5"
    [url]="url"
    [autoSetMeta]="false"
></share-buttons>